<template>
  <div class="bc-white padding-20 br-4">
    <div class="display-flex ai-center jc-space-between">
      <div>
        <b class="fs-18">短信日志</b>
        <p class="page-desc">查看租户到期提醒短信的发送记录。</p>
      </div>
    </div>

    <!-- 搜索 -->
    <div class="display-flex ai-center mt-20">
      <el-input
        v-model="searchForm.tenantName"
        clearable
        placeholder="请输入租户名称"
        style="width: 220px"
        @input="handleFuzzyInput"
        @clear="handleSearch"
        @keyup.enter.native="handleSearch">
      </el-input>
      <el-input
        v-model="searchForm.content"
        clearable
        placeholder="请输入发送内容"
        style="width: 220px"
        class="ml-10"
        @input="handleFuzzyInput"
        @clear="handleSearch"
        @keyup.enter.native="handleSearch">
      </el-input>
      <el-select
        v-model="searchForm.sendStatus"
        clearable
        placeholder="发送状态"
        style="width: 130px"
        class="ml-10"
        @change="handleSearch">
        <el-option label="发送成功" :value="1"></el-option>
        <el-option label="发送失败" :value="0"></el-option>
      </el-select>
      <el-button class="ml-10" type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
      <el-button class="ml-10" icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
    </div>

    <!-- 日志表格 -->
    <el-table class="mt-20" :data="tableData" v-loading="tableLoading" border>
      <el-table-column prop="tenantName" label="租户名称" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="content" label="发送内容" min-width="240"></el-table-column>
      <el-table-column label="发送时间" width="190" align="center">
        <template slot-scope="{ row }">
          <span class="sms-log-time">{{ row.createAt ? $moment(row.createAt).format('YYYY-MM-DD HH:mm:ss') : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="接收人姓名" width="110" align="center">
        <template slot-scope="{ row }">{{ row.userName || '-' }}</template>
      </el-table-column>
      <el-table-column prop="mobile" label="接收人手机号" width="130" align="center">
        <template slot-scope="{ row }">{{ row.mobile || '-' }}</template>
      </el-table-column>
      <el-table-column label="发送状态" width="110" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.sendStatus === 1 ? 'success' : 'danger'" effect="plain">
            {{ row.sendStatus === 1 ? '发送成功' : '发送失败' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="发送失败原因" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <div class="sms-log-copy-cell">
            <span class="sms-log-copy-text cursor-pointer" :class="{ 'color-info': !row.failReason }" @click.stop="openJsonDialog(row.failReason)">{{ row.failReason || '-' }}</span>
            <i class="el-icon-document-copy color-primary cursor-pointer" title="复制发送失败原因" @click.stop="copyText(row.failReason || '-')"></i>
          </div>
        </template>
      </el-table-column>
      <template slot="empty">
        <el-empty description="暂无短信日志" :image-size="80"></el-empty>
      </template>
    </el-table>

    <div class="display-flex jc-flex-end mt-16">
      <el-pagination
        background
        @current-change="handlePageChange"
        :current-page="searchForm.pageNum"
        :page-size="searchForm.pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>

    <json-viewer-dialog
      :visible.sync="jsonDialog.visible"
      title="发送失败原因"
      :value="jsonDialog.value">
    </json-viewer-dialog>
  </div>
</template>

<script>
import JsonViewerDialog from '@/components/JsonViewerDialog'

export default {
  name: 'SmsLog', // 短信日志
  components: { JsonViewerDialog },
  props: {},
  data () {
    return {
      total: 0,
      tableData: [],
      tableLoading: false,
      jsonDialog: { visible: false, value: '' },
      searchTimer: null, // 搜索防抖
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        tenantName: '',
        content: '',
        sendStatus: null
      }
    }
  },
  filters: {},
  watch: {},
  computed: {},
  methods: {
    openJsonDialog (value) {
      this.jsonDialog = { visible: true, value }
    },
    copyText (text) {
      this.$copyText(String(text)).then(() => {
        this.$message.success('已复制')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },
    /**
     * 输入防抖，直接调用查询接口
     */
    handleFuzzyInput () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.handleSearch()
      }, 400)
    },
    /**
     * 查询（重置到第一页）
     */
    handleSearch () {
      this.searchForm.pageNum = 1
      this.getList()
    },
    /**
     * 重置
     */
    handleReset () {
      this.searchForm.tenantName = ''
      this.searchForm.content = ''
      this.searchForm.sendStatus = null
      this.handleSearch()
    },
    /**
     * 翻页
     */
    handlePageChange (val) {
      this.searchForm.pageNum = val
      this.getList()
    },
    /**
     * 短信日志分页列表
     */
    getList () {
      this.tableLoading = true
      const data = {
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      }
      if (this.searchForm.tenantName.trim()) data.tenantName = this.searchForm.tenantName.trim()
      if (this.searchForm.content.trim()) data.content = this.searchForm.content.trim()
      if (this.searchForm.sendStatus !== null && this.searchForm.sendStatus !== '') {
        data.sendStatus = this.searchForm.sendStatus
      }
      this.$api.log.smsLogList(data).then(res => {
        this.tableLoading = false
        this.tableData = res.list || []
        this.total = res.total || 0
      }).catch(() => {
        this.tableLoading = false
      })
    }
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
    this.getList()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
    clearTimeout(this.searchTimer)
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.page-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #909399;
}
.sms-log-time {
  white-space: nowrap;
}
.sms-log-copy-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.sms-log-copy-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
